import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import GetAppIcon from '@material-ui/icons/GetApp'
import { getRequest } from '../../globalhelper/helper'
import _ from 'lodash'
import '../CI/COD.css'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Table,
  Paper,
  TableHead,
  AlertTitle,
  Alert,
  Box
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import moment from 'moment'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { CSVLink } from 'react-csv'

const VendorMaster_Search = props => {
  const [showtable, setShowtable] = useState(false)
  const [formData, setFormData] = useState({
    vendorname: '',
    vendorid: '',
    vendortype: '',
    status: '',
    period: null
  })
  const [tableData, setTableData] = useState([])
  const [displayData, setDisplayData] = useState([])
  const [dropdown_vendorname, setDropdownVendorname] = useState([])
  const [dropdown_vendorid, setDropdownVendorid] = useState([])
  const [dropdown_vendortype, setDropdownVendortype] = useState([])
  const [redirect, setRedirect] = useState(false)
  const [SearchJSON, setSearchJSON] = useState([])

  useEffect(() => {
    sessionStorage.setItem('pageName', 'Search VendorMaster')

    getRequest(`api/edureka/getVM1`).then(res => {
      if (res.res.status === 'success') {
        let temp = JSON.parse(res.res.data)
        console.log(temp)
        let temp1 = temp.map(value => value['Vendor Name'])
        let vendorname = [...new Set(temp1)]?.sort((a, b) => a.localeCompare(b))
        console.log(vendorname)
        let temp3 = temp.map(value => value['Vendor Type'])
        let tem = temp3.filter(value => value)
        let vendortype = [...new Set(tem)]?.sort((a, b) => a.localeCompare(b))

        let vid1 = temp
          .map(value => value['Vendor ID'])
          ?.sort((a, b) => a.localeCompare(b))
        let vid2 = [...new Set(vid1)]?.sort((a, b) => a.localeCompare(b))

        setDropdownVendorname(vendorname)
        setDropdownVendorid(vid2)
        setDropdownVendortype(vendortype)
      } else {
        console.log('No Data')
      }
    })
  }, [])

  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value || ''
    }))
  }

  useEffect(() => {
    if (!formData.period) return

    // if your period is '2025-10'
    const startDate = moment(formData.period, 'YYYY-MM').startOf('month')
    const endDate = moment(formData.period, 'YYYY-MM').endOf('month')

    const filtered = tableData.filter(item => {
      // parse with correct format (DD/MM/YYYY)
      const itemDate = moment(
        item?.['Created At'],
        [
          'YYYY-MM-DDTHH:mm:ss.SSSZ',
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD',
          'DD/MM/YYYY'
        ],
        true
      )
      return (
        itemDate.isSameOrAfter(startDate) && itemDate.isSameOrBefore(endDate)
      )
    })
    // console.log(filtered)

    setDisplayData(filtered)
  }, [formData.period, tableData])

  const handleVendor = i => {
    const vendorid = i['Vendor ID']
    localStorage.setItem(
      'api',
      `api/edureka/getUpdatedDataFromDB`
    )
    localStorage.setItem('apiParams', JSON.stringify({
      "LDE": {
        "OrgID": "NoLDE",
        "Vendor ID": vendorid,
      },
      "Module": localStorage.getItem('module'),
      "screenName": "VendorMaster"
    }))
    window.open(
      `/Dynamic_Forms?token=VendorMaster&action=edit&orgId=NoLDE&docId=${vendorid}`,
      '_blank'
    )
  }

  const handleSearch = () => {
    const { vendorname, vendortype, status, vendorid } = formData

    getRequest(
      `api/edureka/getVMData?vendorname=${vendorname}&vendortype=${vendortype}&status=${status}&vendorid=${vendorid}`
    ).then(res => {
      if (res.res.status === 'success') {
        let temp = JSON.parse(res.res.data)
        console.log(temp)

        setTableData(temp)
        setDisplayData(temp)
        setShowtable(true)
      } else {
        console.log('No Data')
      }
    })
  }

  const handleReset = () => {
    setShowtable(false)
    setFormData({
      vendorname: '',
      vendorid: '',
      vendortype: '',
      status: '',
      period: null
    })
  }

  const onBack = () => {
    setRedirect(false)
    setSearchJSON([])
  }

  if (redirect) {
    return (
      <VR2_Forms
        screenName={'VendorMaster'}
        screenAction={'edit'}
        From_SearchJSON={SearchJSON}
        onBack={onBack}
      />
    )
  }

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel3-content'
          id='panel3-header'
        >
          <Typography variant='h6'>Search Vendor Master</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid spacing={3} container>
            <Grid item xl={2}>
              <Autocomplete
                fullWidth
                label='Vendor Name'
                name='vendorname'
                value={
                  dropdown_vendorname.find(
                    option => option === formData.vendorname
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('vendorname', newValue)}
                options={dropdown_vendorname}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor Name'
                    name='vendorname'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xl={2}>
              <Autocomplete
                fullWidth
                value={
                  dropdown_vendorid.find(
                    option => option === formData.vendorid
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('vendorid', newValue)}
                options={dropdown_vendorid}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor ID'
                    name='vendorid'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xl={2}>
              <Autocomplete
                fullWidth
                value={
                  dropdown_vendortype.find(
                    option => option === formData.vendortype
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('vendortype', newValue)}
                options={dropdown_vendortype}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor Type'
                    name='vendortype'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xl={2}>
              <Autocomplete
                fullWidth
                options={[
                  'Active',
                  'Inactive',
                  'Not Released',
                  'Rejected',
                  'Void',
                  'Waiting For Approval'
                ]}
                value={formData.status}
                onChange={(event, newValue) => {
                  handleChange('status', newValue)
                }}
                renderInput={params => (
                  <TextField
                    name='status'
                    {...params}
                    label='Status'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={4}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSearch}
              >
                Search
              </Button>
              &nbsp;
              <Button variant='contained' color='error' onClick={handleReset}>
                Reset
              </Button>
              &nbsp;
              <Button
                variant='contained'
                color='warning'
                onClick={() => props.onBack()}
              >
                Back
              </Button>
            </Grid>
          </Grid>
          {tableData.length > 0 && (
            <>
              <Typography variant='h6' mt={2}>
                Filter
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={1} sm={2} md={4}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label='Period'
                      value={formData.period}
                      views={['month', 'year']}
                      onChange={newValue => {
                        handleChange('period', newValue)
                      }}
                      renderInput={params => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </>
          )}
        </AccordionDetails>
      </Accordion>

      {(showtable && tableData.length > 0 && (
        <div>
          <Box align='right'>
            <Button color='success' variant='contained'>
              <CSVLink
                style={{ color: 'white', textDecoration: 'none' }}
                data={tableData}
                filename='GRN.csv'
              >
                <GetAppIcon />
              </CSVLink>
            </Button>
          </Box>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>Vendor ID</TableCell>
                  <TableCell sx={{ whiteSpace: 'normal' }}>
                    Vendor Name
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    Member Type
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    GST Treatment
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>State</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    Created At
                  </TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>Status</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>
                    Vendor Group
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(displayData.length > 0 &&
                  displayData
                    .sort((a, b) =>
                      a['Vendor ID'].localeCompare(b['Vendor ID'])
                    )
                    .map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            <Button
                              variant='text'
                              color='primary'
                              onClick={() => handleVendor(item)}
                            >
                              {item['Vendor ID']}
                            </Button>
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'normal' }}>
                            {item['Vendor Name']}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {item['Member Type']}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {item['GST Treatment']}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {item['State']}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {moment(item['Created At']).format('DD/MM/YYYY')}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {item['Status']}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {item['Vendor Group']}
                          </TableCell>
                        </TableRow>
                      )
                    })) || (
                    <TableRow>
                      <TableCell colSpan={7}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                          }}
                        >
                          <Alert severity='error' variant='outlined'>
                            No matching records found. Please adjust your search criteria.
                          </Alert>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )) ||
        (showtable && (
          <Box sx={{ margin: 'auto' }}>
            <Alert severity='warning'>
              <AlertTitle>No Data Found</AlertTitle>
              There is no data to display at the moment.
            </Alert>
          </Box>
        ))}
    </>
  )
}

const mapStateToProps = state => {
  return {
    userData: state.login.userData
  }
}

export default connect(mapStateToProps)(VendorMaster_Search)